<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <form class="modal-content">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">
                            <template v-if="vehicleCount == 1">
                                Select A Vehicle to book in the job
                            </template>
                            <template v-else>
                                Select {{ vehicleCount }} Vehicles to book in the jobs
                            </template>
                        </h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content fs-sm">
                        <template v-for="index in vehicleCount">
                            <div class="mb-4" v-show="addNew === false">
                                <label class="form-label" for="vehicle_id">
                                    Select Vehicle
                                    <template v-if="vehicleCount > 1">
                                        #{{ index }}
                                    </template>
                                </label>
                                <UniversalSelect2
                                    placeholder="Select Or Add"
                                    name="vehicle_id[]"
                                    :route="routes.selectVehicle"
                                    :required="true"
                                    :query-string-params="{vehicletype_id: vehicletypeId}"
                                    :can-add-new="true"
                                    v-model="selectedVehicleId[index - 1]"
                                ></UniversalSelect2>
                            </div>
                        </template>
                        <template v-if="addNew">
                            <div class="mb-4">
                                <label for="vin-input" class="form-label">VIN *</label>
                                <input type="text" class="form-control" id="reg-input" v-model="vehicleReg" required>
                            </div>
                            <div class="mb-4">
                                <label for="make-input" class="form-label">Make</label>
                                <input type="text" class="form-control" id="make-input" v-model="vehicleMake">
                            </div>
                            <div class="mb-4">
                                <label for="model-input" class="form-label">Model</label>
                                <input type="text" class="form-control" id="model-input" v-model="vehicleModel">
                            </div>
                            <div class="mb-4">
                                <label for="colour-input" class="form-label">Colour</label>
                                <input type="text" class="form-control" id="colour-input" v-model="vehicleColour">
                            </div>
                        </template>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" v-if="addNew === false" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" v-else v-on:click="addNew = false">Close</button>
                        <button type="button" class="btn btn-sm btn-primary" v-on:click="submit">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal'
import { Eventbus } from '@/components/eventbus';

import UniversalSelect2 from '@/components/universal-select-2.vue';

export default {
    components: { UniversalSelect2 },
    props: {
        saveModalRoute: String,
        quote: Object,
        vehicletypeId: Number,
        routes: Object,
        vehicleCount: Number,
    },
    data() {
        return {
            addNew: false,
            selectedVehicleId: Array.from(Array(this.vehicleCount)),
            vehicleColour: "",
            vehicleMake: "",
            vehicleModel: "",
            vehicleReg: ""
        };
    },
    mounted() {
        this.modal = new Modal(this.$el);
        Eventbus.on("accept-quote", () => {
            this.modal.show();
        });

        this.$el.addEventListener('hidden.bs.modal', () => {
            this.addNew = false;
        });

        Eventbus.on('add-new' + 'vehicle_id[]', () => {
            this.addNew = true;
        });
    },
    methods: {
        async submit() {
            if (this.addNew) {
                const newVehicle = await axios.post(this.routes.saveVehicleRoute, {
                    reg: this.vehicleReg,
                    make: this.vehicleMake,
                    model: this.vehicleModel,
                    colour: this.vehicleColour,
                    vehicletype_id: this.vehicletypeId
                });

                // this code is pointless but here for reference if we stop using select2 at any point
                // for (let i in this.selectedVehicleId) {
                //     if (this.selectedVehicleId[i] === undefined || this.selectedVehicleId[i] === null || this.selectedVehicleId[i] == '') {
                //         this.selectedVehicleId[i] = newVehicle.data;
                //         break;
                //     }
                // }

                this.addNew = false;

                this.vehicleColour = "";
                this.vehicleMake = "";
                this.vehicleModel = "";
                this.vehicleReg = "";

                return;
            }

            for (let i in this.selectedVehicleId) {
                if (this.selectedVehicleId[i] === undefined || this.selectedVehicleId[i] == '' || this.selectedVehicleId[i] === null) {
                    alert('missing id');
                    return;
                }
            }

            //send email as notification on quote submit
            axios.post(this.routes.submitRoute, {
                vehicle_id: this.selectedVehicleId
            }).then(() => {
                window.location.reload();
            }).catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Could not save job",
                    text: "System error. We were unable to save your job",
                });
            });
        },
    },
}
</script>
